import {
  JobPosting,
  JobPostingFormData,
  JobPostingJSON,
  JobPostingResponse,
  JobPostingsJSON,
  LanguageSkill,
} from '../types/JobPostingsTypes';

import {Skill} from '../../../../../types/shared-types';
import {SerializeTo} from '../../../../../utils/serializer/serialize';

export default class JobPostingsSerializer {
  static toObject(payload: JobPostingJSON): JobPosting {
    return SerializeTo.CamelCase<JobPostingResponse>(payload).companyJobPosting;
  }

  static toObjects(payload: JobPostingsJSON): JobPosting[] {
    return payload.company_job_postings.map((company_job_posting) =>
      JobPostingsSerializer.toObject({company_job_posting: company_job_posting})
    );
  }

  static toPayloadJSON(jobPostingFormData: JobPostingFormData, isUpdate?: boolean): any {
    const remoteHiring = isUpdate
      ? (jobPostingFormData.remoteHiring as unknown as {allowed: boolean})?.allowed
      : (jobPostingFormData.remoteHiring as boolean);

    return {
      company_job_posting: {
        title: jobPostingFormData.title,
        salary: {
          min: jobPostingFormData.salary?.min,
          max: jobPostingFormData.salary?.max,
        },
        work_mode: jobPostingFormData.workMode,
        experience: {
          years_of_experience: jobPostingFormData.experience?.yearsOfExperience,
          years_of_leadership: jobPostingFormData.experience?.yearsOfLeadership || 0,
        },
        language_skills: jobPostingFormData.languageSkills?.map((languageSkill: LanguageSkill) => ({
          language: languageSkill.language,
          level: languageSkill.level,
        })),
        employment_type: jobPostingFormData.employmentType,
        degree: jobPostingFormData.degree,
        company_departments: jobPostingFormData.departments,
        company_subdepartments: jobPostingFormData.subdepartments,
        locations: jobPostingFormData.locations,
        remote_hiring: {
          allowed: !!remoteHiring,
          region: 'anywhere',
        },
        requirements: jobPostingFormData.requirements.split('\n').map((requirement: string) => requirement.trim()),
        responsibilities: jobPostingFormData.responsibilities
          .split('\n')
          .map((responsibility: string) => responsibility.trim()),
        skills: jobPostingFormData.skills?.map((skill: Skill) => {
          return {
            standard_skill_id: skill.resourceId || skill.standardSkillId || '',
          };
        }),
        published_at: jobPostingFormData.publishedAt,
        metadata: jobPostingFormData.metadata,
        company_admin_ids: jobPostingFormData.companyAdminIds,
      },
    };
  }
}
